module.exports = __webpack_public_path__ + "static/media/plugit.4dd19e32.svg";